'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

function OvernightFeeCalculationParameters(domainBuilder) {
  domainBuilder.defineModel('OvernightFeeCalculationParameters', 'overnightFeeCalculationParameters', function (model) {
    return model.define({
      defaults: {
        annualPercent: Number.value(null),
        onBorrowedMoneyOnly: Boolean.value(null),
        annualPercentOverBpFine: Number.value(null)
      },
      toJSON: function toJSON() {
        return this.attributes;
      }
    });
  });
}

exports.default = OvernightFeeCalculationParameters;


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/statements-domain/dist/models/OvernightFeeCalculationParameters.js
// module id = 1430
// module chunks = 118